<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="delete-user-view">
    <div class="delete-wrap">
      <div class="delete-head">
        <div class="icon-ajuntament" />
      </div>
      <h2>{{ $t('drop_out') }}</h2>
      <p class="delete-explain">{{ $t('delete_user') }}</p>
      <div class="input-wrapper">
        <span class="question">{{ $t('email') }}</span>
        <input
          v-model="emailInput"
          class="delete-input"
          :class="hasEmailError && 'error'"
          type="text"
          :placeholder="$t('email_ex')"
        >
      </div>
      <div class="bottom-wrapper">
        <div class="button-wrap" @click="validateDeleteUser">
          <span>{{ $t('confirm') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deleteUser } from '@/services/user-api'
export default {
  components: {},
  props: {},
  data() {
    return {
      emailInput: '',
      hasEmailError: false,
    }
  },
  computed: {},
  watch: {
    emailInput() {
      this.hasEmailError = false
    },
  },
  methods: {
    /**
     * Update the current route with new params if current page is different
     * @param {String} routeName Name of page that user want's to navigate
     * @public This is a public method
     */
    routeChange(routeName) {
      if (this.$route.name !== routeName) this.$router.push({ name: routeName })
    },
    validateDeleteUser() {
      let reg = /[^\s]*@[a-z0-9.-]*/i

      //this.$route.query.email
      if ((this.emailInput === '' || !reg.test(this.emailInput)) && !this.hasEmailError) {
        this.hasEmailError = true
      }
      if (!this.hasEmailError) {
        deleteUser(this.emailInput)
          .then(resp => {
            resp
            this.$store.dispatch('deleteUser').then(() => {
              this.$router.push({ name: 'ConfirmDelete' })
            })
          })
          .catch(err => {
            err
          })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.delete-user-view
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)
  background-color: rgba($bcn-dark-blue-gray, 0.05)

  .delete-wrap
    display: flex
    flex-direction: column
    align-items: center
    padding: vw(20px)
    min-width: 250px
    width: 60%
    border-radius: 8px
    background-color: #fff
    box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)
    gap: vw(5px)

    .bottom-wrapper
      margin-top: vw(20px)
      width: 50%

      span
        m-font-size(12, 20)
        margin-right: vw(4px)

      .button-wrap
        display: flex
        justify-content: center
        margin: vw(5px) 0
        padding: vw(8px) 0
        border-radius: 4px
        background-color: black
        cursor: pointer

        span
          color: white
          m-font-size(14, 20)

    .delete-head
      display: flex
      justify-content: space-between
      width: 100%

      .icon-ajuntament
        width: vw(176px)
        height: vw(45px)
        background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
        background-position: center center
        background-size: cover
        background-repeat: no-repeat

    h2
      margin-block-start: 1.5em
      font-size(32, 44)
      font-weight: 600

    .delete-explain
      font-size(20, 24)
      margin-bottom: vw(20px)
      width: 85%
      font-weight: 400

    .input-wrapper
      display: flex
      flex-direction: column
      margin-bottom: vw(15px)
      width: 85%
      gap: vw(5px)

      .question
        m-font-size(14, 20)
        color: $grey
        font-weight: 400

      .delete-input
        m-font-size(16, 20)
        position: relative
        padding: 0
        padding-right: vw(10px)
        padding-left: vw(10px)
        width: 100%
        height: vw(48px)
        outline: none
        border: 1px solid $grey-grey
        border-radius: 4px
        background-color: $light-grey
        color: #000
        font-weight: 600

        &.error
          border: 2px solid $warning
</style>